<div class="border-gray-100 border-1 p-2 border-round-sm">
  <div class="flex justify-content-between align-content-center">
    <div class="flex align-items-center">
      <div *ngIf="supplierTask.isCurrent" class="status-indicator bg-green-500 mr-1"></div>
      <h4 class="my-0">{{ supplierTask.vehicleReg }}</h4>
    </div>

    <task-review-status
      [riskStatus]="supplierTask.reviewStatus"
      [reviewDate]="supplierTask.reviewDate"
      [taskId]="supplierTask.taskId"
      (riskStatusChange)="handleRiskStatusChange($event, supplierTask.taskId)"
    ></task-review-status>
  </div>

  <div class="flex gap-2">
    <span>{{ supplierTask.durationMinutes | minutesToHoursMinutes }}</span>
    <span>•</span>
    <span class="ml-1">{{ supplierTask.mileage }} mi</span>
  </div>

  <div class="flex align-items-center my-1">
    <i class="fa fa-map-marker mr-2 text-gray-700"></i>
    <span class="bold-text">{{ supplierTask.pickupLocation }}</span
    >, Latest {{ supplierTask.latestDriverPickup | datex : 'HH:mm' }}
    <i class="fa fa-arrow-right mx-2"></i>
    <span class="bold-text">{{ supplierTask.dropoffLocation }}</span
    >, Latest {{ supplierTask.latestDriverDropoff | datex : 'HH:mm' }}
  </div>

  <div class="flex gap-2 mt-2">
    <risk-pill *ngFor="let risk of supplierTask.risks">{{ risk.title }}</risk-pill>
  </div>
</div>
